import React from 'react';
import './ExploreSection.css';
import { Link } from 'react-router-dom';

const exploreItems = [
  {
    num: "01",
    title: "My Journey",
    desc: "Where I've been, what I've built, and the path that led here.",
    link: "/journey",
    tag: "Background",
  },
  {
    num: "02",
    title: "Skills & Expertise",
    desc: "Contract law, commercial drafting, negotiation — no fluff, just facts.",
    link: "/skills",
    tag: "Expertise",
  },
  {
    num: "03",
    title: "Contract Tips",
    desc: "Practical guidance for freelancers, businesses and growing teams.",
    link: "/contract-tips",
    tag: "Resources",
  },
  {
    num: "04",
    title: "Work With Me",
    desc: "Let's build professional relationships that actually hold up.",
    link: "/work-with-me",
    tag: "Services",
  },
];

function ExploreSection() {
  return (
    <section className="explore-section" id="explore">
      <div className="explore-inner">

        <div className="explore-header">
          <span className="explore-kicker">✦ Explore</span>
          <h2 className="explore-heading">Everything<br />in one place.</h2>
          <p className="explore-sub">
            From my background to the work I do — start anywhere.
          </p>
        </div>

        <div className="explore-grid">
          {exploreItems.map((item) => (
            <Link to={item.link} className="explore-card" key={item.num}>
              <span className="explore-card-tag">{item.tag}</span>
              <span className="explore-card-num">{item.num}</span>
              <div className="explore-card-body">
                <h3 className="explore-card-title">{item.title}</h3>
                <p className="explore-card-desc">{item.desc}</p>
              </div>
              <span className="explore-card-cta">
                Explore <span className="explore-arrow">→</span>
              </span>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ExploreSection;
